
import { defineComponent } from 'vue';
import { BlockItemPrice, BlockItemPriceType } from "@/models/Blocks/Itens/Types/block-item-price";

export default defineComponent({
    props:{
        variant:{
            type: String,
            default: undefined
        },
        names:{
            type: Array<String>,
            default: () => new Array<String>()
        },
        prices:{
            type: Array<BlockItemPrice>,
            default: () => new Array<BlockItemPrice>()
        }
    },
    methods: {
        isPriceStrikethrough(value: BlockItemPrice): boolean {
            return value.type == BlockItemPriceType.strikethrough;
        }
    }
});
